"use client";
import { createGlobalStyle } from "styled-components";
import { globalTextStyles } from "../../foundation/typography/index.js";
const RegisterSkodaDarkTheme = createGlobalStyle`
    .theme-skoda {
  --moller-opacity-on-focus: 0.16;
  --moller-opacity-on-pressed: 0.16;
  --moller-opacity-on-hover: 0.08;
  --moller-opacity-percentage-16: 0.16;
  --moller-opacity-percentage-8: 0.08;
  --moller-elevation-high: 0px 0px 1px 0px #0000003d, 0px 2px 16px 0px #00000014, 0px 8px 48px 0px #0000000f;
  --moller-elevation-medium: 0px 0px 1px 0px #0000003d, 0px 4px 8px 0px #0000000a, 0px 8px 24px 0px #0000000f;
  --moller-elevation-low: 0px 0px 1px 0px #0000003d, 0px 1px 4px 0px #0000000a, 0px 4px 8px 0px #0000000f;
  --moller-elevation-none: 0px 0px 0px 0px #00000000;
  --moller-border-radius-full: 999px;
  --moller-border-radius-xx-large: 16px;
  --moller-border-radius-x-large: 12px;
  --moller-border-radius-large: 8px;
  --moller-border-radius-medium: 4px;
  --moller-border-radius-small: 2px;
  --moller-border-radius-none: 0px;
  --moller-stroke-large: 4px;
  --moller-stroke-medium: 2px;
  --moller-stroke-small: 1px;
  --moller-stroke-x-small: 0.5px;
  --moller-keycolor-interactive: #419468;
  --moller-keycolor-info: #3784D1;
  --moller-keycolor-success: #359204;
  --moller-keycolor-warning: #D87F16;
  --moller-keycolor-error: #EA443B;
  --moller-keycolor-neutral-variant: #5A5B5C;
  --moller-keycolor-neutral: #7C7D7E;
  --moller-keycolor-tertiary-variant: #3A6558;
  --moller-keycolor-tertiary: #419468;
  --moller-keycolor-secondary: #419468;
  --moller-keycolor-primary: #419468;
  --moller-size-4xl: 64px;
  --moller-size-3xl: 48px;
  --moller-size-xxl: 40px;
  --moller-size-xl: 32px;
  --moller-size-l: 24px;
  --moller-size-m: 20px;
  --moller-size-s: 16px;
  --moller-size-xs: 12px;
  --moller-size-xxs: 8px;
  --moller-size-base: 4px;
  --moller-spacing-3xl: 48px;
  --moller-spacing-xxl: 40px;
  --moller-spacing-xl: 32px;
  --moller-spacing-l: 24px;
  --moller-spacing-m: 20px;
  --moller-spacing-s: 16px;
  --moller-spacing-xs: 12px;
  --moller-spacing-xxs: 8px;
  --moller-spacing-base: 4px;
  --moller-spacing-none: 0px;
  --moller-type-compact-notice-text-case: none;
  --moller-type-compact-notice-text-decoration: none;
  --moller-type-compact-notice-paragraph-spacing: 0.75rem;
  --moller-type-compact-notice-letter-spacing: 0;
  --moller-type-compact-notice-font-size: 0.75rem;
  --moller-type-compact-notice-line-height: 1.4;
  --moller-type-compact-notice-font-weight: 500;
  --moller-type-compact-notice-font-family: SKODANext;
  --moller-type-compact-label-text-case: none;
  --moller-type-compact-label-text-decoration: none;
  --moller-type-compact-label-paragraph-spacing: 0.625rem;
  --moller-type-compact-label-letter-spacing: 0;
  --moller-type-compact-label-font-size: 0.625rem;
  --moller-type-compact-label-line-height: 1.4;
  --moller-type-compact-label-font-weight: 400;
  --moller-type-compact-label-font-family: SKODANext;
  --moller-type-compact-action-text-case: none;
  --moller-type-compact-action-text-decoration: none;
  --moller-type-compact-action-paragraph-spacing: 0.875rem;
  --moller-type-compact-action-letter-spacing: 0;
  --moller-type-compact-action-font-size: 0.875rem;
  --moller-type-compact-action-line-height: 1.4;
  --moller-type-compact-action-font-weight: 500;
  --moller-type-compact-action-font-family: SKODANext;
  --moller-type-default-notice-text-case: none;
  --moller-type-default-notice-text-decoration: none;
  --moller-type-default-notice-paragraph-spacing: 1rem;
  --moller-type-default-notice-letter-spacing: 0;
  --moller-type-default-notice-font-size: 1rem;
  --moller-type-default-notice-line-height: 1.4;
  --moller-type-default-notice-font-weight: 500;
  --moller-type-default-notice-font-family: SKODANext;
  --moller-type-default-label-text-case: none;
  --moller-type-default-label-text-decoration: none;
  --moller-type-default-label-paragraph-spacing: 0.75rem;
  --moller-type-default-label-letter-spacing: 0;
  --moller-type-default-label-font-size: 0.75rem;
  --moller-type-default-label-line-height: 1.4;
  --moller-type-default-label-font-weight: 400;
  --moller-type-default-label-font-family: SKODANext;
  --moller-type-default-action-text-case: none;
  --moller-type-default-action-text-decoration: none;
  --moller-type-default-action-paragraph-spacing: 1rem;
  --moller-type-default-action-letter-spacing: 0;
  --moller-type-default-action-font-size: 1rem;
  --moller-type-default-action-line-height: 1.4;
  --moller-type-default-action-font-weight: 500;
  --moller-type-default-action-font-family: SKODANext;
  --moller-type-small-description-text-case: none;
  --moller-type-small-description-text-decoration: none;
  --moller-type-small-description-paragraph-spacing: 0.75rem;
  --moller-type-small-description-letter-spacing: 0;
  --moller-type-small-description-font-size: 0.75rem;
  --moller-type-small-description-line-height: 1.4;
  --moller-type-small-description-font-weight: 400;
  --moller-type-small-description-font-family: SKODANext;
  --moller-type-small-link-text-case: none;
  --moller-type-small-link-text-decoration: underline;
  --moller-type-small-link-paragraph-spacing: 1rem;
  --moller-type-small-link-letter-spacing: 0;
  --moller-type-small-link-font-size: 1rem;
  --moller-type-small-link-line-height: 1.4;
  --moller-type-small-link-font-weight: 400;
  --moller-type-small-link-font-family: SKODANext;
  --moller-type-small-body-text-case: none;
  --moller-type-small-body-text-decoration: none;
  --moller-type-small-body-paragraph-spacing: 1rem;
  --moller-type-small-body-letter-spacing: 0;
  --moller-type-small-body-font-size: 1rem;
  --moller-type-small-body-line-height: 1.4;
  --moller-type-small-body-font-weight: 400;
  --moller-type-small-body-font-family: SKODANext;
  --moller-type-small-lead-text-case: none;
  --moller-type-small-lead-text-decoration: none;
  --moller-type-small-lead-paragraph-spacing: 1.25rem;
  --moller-type-small-lead-letter-spacing: 0;
  --moller-type-small-lead-font-size: 1.25rem;
  --moller-type-small-lead-line-height: 1.4;
  --moller-type-small-lead-font-weight: 400;
  --moller-type-small-lead-font-family: SKODANext;
  --moller-type-small-overline-text-case: uppercase;
  --moller-type-small-overline-text-decoration: none;
  --moller-type-small-overline-paragraph-spacing: 1.125rem;
  --moller-type-small-overline-letter-spacing: 0;
  --moller-type-small-overline-font-size: 0.75rem;
  --moller-type-small-overline-line-height: 1.4;
  --moller-type-small-overline-font-weight: 500;
  --moller-type-small-overline-font-family: SKODANext;
  --moller-type-small-headline-text-case: none;
  --moller-type-small-headline-text-decoration: none;
  --moller-type-small-headline-paragraph-spacing: 2.25rem;
  --moller-type-small-headline-letter-spacing: 0;
  --moller-type-small-headline-font-size: 1.5rem;
  --moller-type-small-headline-line-height: 1.4;
  --moller-type-small-headline-font-weight: 500;
  --moller-type-small-headline-font-family: SKODANext;
  --moller-type-small-display-text-case: none;
  --moller-type-small-display-text-decoration: none;
  --moller-type-small-display-paragraph-spacing: 3rem;
  --moller-type-small-display-letter-spacing: 0;
  --moller-type-small-display-font-size: 2rem;
  --moller-type-small-display-line-height: 1.4;
  --moller-type-small-display-font-weight: 500;
  --moller-type-small-display-font-family: SKODANext;
  --moller-type-small-subtitle-text-case: none;
  --moller-type-small-subtitle-text-decoration: none;
  --moller-type-small-subtitle-letter-spacing: 0;
  --moller-type-small-subtitle-paragraph-spacing: 1.5rem;
  --moller-type-small-subtitle-font-size: 0.875rem;
  --moller-type-small-subtitle-line-height: 1.4;
  --moller-type-small-subtitle-font-weight: 400;
  --moller-type-small-subtitle-font-family: SKODANext;
  --moller-type-medium-description-text-case: none;
  --moller-type-medium-description-text-decoration: none;
  --moller-type-medium-description-paragraph-spacing: 0.75rem;
  --moller-type-medium-description-letter-spacing: 0;
  --moller-type-medium-description-font-size: 0.75rem;
  --moller-type-medium-description-line-height: 1.4;
  --moller-type-medium-description-font-weight: 400;
  --moller-type-medium-description-font-family: SKODANext;
  --moller-type-medium-link-text-case: none;
  --moller-type-medium-link-text-decoration: underline;
  --moller-type-medium-link-paragraph-spacing: 1rem;
  --moller-type-medium-link-letter-spacing: 0;
  --moller-type-medium-link-font-size: 1rem;
  --moller-type-medium-link-line-height: 1.4;
  --moller-type-medium-link-font-weight: 400;
  --moller-type-medium-link-font-family: SKODANext;
  --moller-type-medium-body-text-case: none;
  --moller-type-medium-body-text-decoration: none;
  --moller-type-medium-body-paragraph-spacing: 1rem;
  --moller-type-medium-body-letter-spacing: 0;
  --moller-type-medium-body-font-size: 1rem;
  --moller-type-medium-body-line-height: 1.4;
  --moller-type-medium-body-font-weight: 400;
  --moller-type-medium-body-font-family: SKODANext;
  --moller-type-medium-lead-text-case: none;
  --moller-type-medium-lead-text-decoration: none;
  --moller-type-medium-lead-paragraph-spacing: 1.5rem;
  --moller-type-medium-lead-letter-spacing: 0;
  --moller-type-medium-lead-font-size: 1.5rem;
  --moller-type-medium-lead-line-height: 1.4;
  --moller-type-medium-lead-font-weight: 400;
  --moller-type-medium-lead-font-family: SKODANext;
  --moller-type-medium-overline-text-case: uppercase;
  --moller-type-medium-overline-text-decoration: none;
  --moller-type-medium-overline-paragraph-spacing: 1.5rem;
  --moller-type-medium-overline-letter-spacing: 0;
  --moller-type-medium-overline-font-size: 1rem;
  --moller-type-medium-overline-line-height: 1.4;
  --moller-type-medium-overline-font-weight: 500;
  --moller-type-medium-overline-font-family: SKODANext;
  --moller-type-medium-headline-text-case: none;
  --moller-type-medium-headline-text-decoration: none;
  --moller-type-medium-headline-paragraph-spacing: 2.625rem;
  --moller-type-medium-headline-letter-spacing: 0;
  --moller-type-medium-headline-font-size: 1.75rem;
  --moller-type-medium-headline-line-height: 1.4;
  --moller-type-medium-headline-font-weight: 500;
  --moller-type-medium-headline-font-family: SKODANext;
  --moller-type-medium-display-text-case: none;
  --moller-type-medium-display-text-decoration: none;
  --moller-type-medium-display-paragraph-spacing: 4.5rem;
  --moller-type-medium-display-letter-spacing: 0;
  --moller-type-medium-display-font-size: 3rem;
  --moller-type-medium-display-line-height: 1.4;
  --moller-type-medium-display-font-weight: 500;
  --moller-type-medium-display-font-family: SKODANext;
  --moller-type-medium-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-medium-subtitle-text-case: none;
  --moller-type-medium-subtitle-text-decoration: none;
  --moller-type-medium-subtitle-letter-spacing: 0;
  --moller-type-medium-subtitle-font-size: 1.25rem;
  --moller-type-medium-subtitle-line-height: 1.4;
  --moller-type-medium-subtitle-font-weight: 400;
  --moller-type-medium-subtitle-font-family: SKODANext;
  --moller-type-large-description-text-case: none;
  --moller-type-large-description-text-decoration: none;
  --moller-type-large-description-paragraph-spacing: 0.875rem;
  --moller-type-large-description-letter-spacing: 0;
  --moller-type-large-description-font-size: 0.875rem;
  --moller-type-large-description-line-height: 1.4;
  --moller-type-large-description-font-weight: 400;
  --moller-type-large-description-font-family: SKODANext;
  --moller-type-large-link-text-case: none;
  --moller-type-large-link-text-decoration: underline;
  --moller-type-large-link-paragraph-spacing: 1rem;
  --moller-type-large-link-letter-spacing: 0;
  --moller-type-large-link-font-size: 1rem;
  --moller-type-large-link-line-height: 1.4;
  --moller-type-large-link-font-weight: 400;
  --moller-type-large-link-font-family: SKODANext;
  --moller-type-large-body-text-case: none;
  --moller-type-large-body-text-decoration: none;
  --moller-type-large-body-paragraph-spacing: 1rem;
  --moller-type-large-body-letter-spacing: 0;
  --moller-type-large-body-font-size: 1rem;
  --moller-type-large-body-line-height: 1.4;
  --moller-type-large-body-font-weight: 400;
  --moller-type-large-body-font-family: SKODANext;
  --moller-type-large-lead-text-case: none;
  --moller-type-large-lead-text-decoration: none;
  --moller-type-large-lead-paragraph-spacing: 1.75rem;
  --moller-type-large-lead-letter-spacing: 0;
  --moller-type-large-lead-font-size: 1.75rem;
  --moller-type-large-lead-line-height: 1.4;
  --moller-type-large-lead-font-weight: 400;
  --moller-type-large-lead-font-family: SKODANext;
  --moller-type-large-overline-text-case: uppercase;
  --moller-type-large-overline-text-decoration: none;
  --moller-type-large-overline-paragraph-spacing: 1.5rem;
  --moller-type-large-overline-letter-spacing: 0;
  --moller-type-large-overline-font-size: 1rem;
  --moller-type-large-overline-line-height: 1.4;
  --moller-type-large-overline-font-weight: 500;
  --moller-type-large-overline-font-family: SKODANext;
  --moller-type-large-headline-text-case: none;
  --moller-type-large-headline-text-decoration: none;
  --moller-type-large-headline-paragraph-spacing: 3rem;
  --moller-type-large-headline-letter-spacing: 0;
  --moller-type-large-headline-font-size: 2rem;
  --moller-type-large-headline-line-height: 1.4;
  --moller-type-large-headline-font-weight: 500;
  --moller-type-large-headline-font-family: SKODANext;
  --moller-type-large-display-text-case: none;
  --moller-type-large-display-text-decoration: none;
  --moller-type-large-display-paragraph-spacing: 5.25rem;
  --moller-type-large-display-letter-spacing: 0;
  --moller-type-large-display-font-size: 3.5rem;
  --moller-type-large-display-line-height: 1.4;
  --moller-type-large-display-font-weight: 500;
  --moller-type-large-display-font-family: SKODANext;
  --moller-type-large-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-large-subtitle-text-case: none;
  --moller-type-large-subtitle-text-decoration: none;
  --moller-type-large-subtitle-letter-spacing: 0;
  --moller-type-large-subtitle-font-size: 1.5rem;
  --moller-type-large-subtitle-line-height: 1.4;
  --moller-type-large-subtitle-font-weight: 400;
  --moller-type-large-subtitle-font-family: SKODANext;
  --moller-radius-feedback: 0px;
  --moller-radius-overlay: 0px;
  --moller-radius-picker: 0px;
  --moller-radius-input: 0px;
  --moller-radius-checkbox: 0px;
  --moller-radius-card: 8px;
  --moller-radius-button: 999px;
  --moller-color-on-info-container: #00162e;
  --moller-color-info-container: #dbe5ff;
  --moller-color-on-info: #ffffff;
  --moller-color-info: #3784d1;
  --moller-color-on-success-container: #032100;
  --moller-color-success-container: #dbf8db;
  --moller-color-on-success: #ffffff;
  --moller-color-on-warning-container: #331e00;
  --moller-color-warning-container: #fff8db;
  --moller-color-on-warning: #000000;
  --moller-color-warning: #d87f16;
  --moller-color-on-error-container: #330000;
  --moller-color-error-container: #ffe4db;
  --moller-color-on-error: #ffffff;
  --moller-color-error: #ea443b;
  --moller-color-on-disabled-variant: #464748;
  --moller-color-disabled-variant: #ffffff;
  --moller-color-outline: #d8d8d8;
  --moller-color-on-disabled: #7c7d7e;
  --moller-color-disabled: #f1f1f1;
  --moller-color-on-tertiary-variant: #000000;
  --moller-color-on-tertiary-container: #263e31;
  --moller-color-tertiary-container: #cfffe3;
  --moller-color-on-tertiary: #000000;
  --moller-color-on-secondary-container: #263e31;
  --moller-color-secondary-container: #cfffe3;
  --moller-color-secondary: #419468;
  --moller-color-on-primary-container: #263e31;
  --moller-color-primary-container: #cfffe3;
  --moller-color-success: #4baa24;
  --moller-color-on-loader: #7c7d7e;
  --moller-color-loader: #9e9fa0;
  --moller-color-highlight: #419468;
  --moller-color-interactive: #78faae;
  --moller-color-on-surface-variant: #ffffff;
  --moller-color-surface-variant: #303132;
  --moller-color-on-surface: #ffffff;
  --moller-color-surface: #5a5b5c;
  --moller-color-on-inverse-background: #000000;
  --moller-color-inverse-background: #ffffff;
  --moller-color-on-background: #ffffff;
  --moller-color-background: #161718;
  --moller-color-tertiary-variant: #84b5a6;
  --moller-color-tertiary: #78faae;
  --moller-color-on-secondary: #ffffff;
  --moller-color-on-primary: #000000;
  --moller-color-primary: #78faae;
  --moller-typeface-text-decoration-strikethrough: line-through;
  --moller-typeface-text-decoration-line: underline;
  --moller-typeface-text-decoration-none: none;
  --moller-typeface-text-case-lowercase: lowercase;
  --moller-typeface-text-case-uppercase: uppercase;
  --moller-typeface-text-case-none: none;
  --moller-typeface-letter-spacing-none: 0;
  --moller-typeface-size-4xl: 3.5rem;
  --moller-typeface-size-3xl: 3rem;
  --moller-typeface-size-xxl: 2rem;
  --moller-typeface-size-xl: 1.75rem;
  --moller-typeface-size-l: 1.5rem;
  --moller-typeface-size-m: 1.25rem;
  --moller-typeface-size-base: 1rem;
  --moller-typeface-size-s: 0.875rem;
  --moller-typeface-size-xs: 0.75rem;
  --moller-typeface-size-xxs: 0.625rem;
  --moller-typeface-weight-bold: 500;
  --moller-typeface-weight-regular: 400;
  --moller-typeface-line-height: 1.4;
  --moller-typeface-brand-display: SKODA Next;
  --moller-typeface-brand: SKODANext;
  --moller-palette-white: #ffffff;
  --moller-palette-black: #000000;
  --moller-palette-tertiary-variant-95: #EDF9F5;
  --moller-palette-tertiary-variant-90: #CFE8E0;
  --moller-palette-tertiary-variant-80: #9EC8BB;
  --moller-palette-tertiary-variant-70: #84B5A6;
  --moller-palette-tertiary-variant-60: #649586;
  --moller-palette-tertiary-variant-50: #4B7A6C;
  --moller-palette-tertiary-variant-40: #3A6558;
  --moller-palette-tertiary-variant-30: #1F5044;
  --moller-palette-tertiary-variant-20: #0E3A2F;
  --moller-palette-tertiary-variant-10: #00271D;
  --moller-palette-interactive-95: #E8FFF1;
  --moller-palette-interactive-90: #CFFFE3;
  --moller-palette-interactive-80: #A8FFCC;
  --moller-palette-interactive-70: #78FAAE;
  --moller-palette-interactive-60: #72E3A1;
  --moller-palette-interactive-50: #59BC87;
  --moller-palette-interactive-40: #419468;
  --moller-palette-interactive-30: #31694B;
  --moller-palette-interactive-20: #2D5540;
  --moller-palette-interactive-10: #263E31;
  --moller-palette-error-95: #FFE4DB;
  --moller-palette-error-90: #FFC8B6;
  --moller-palette-error-80: #FFAB96;
  --moller-palette-error-70: #FF8F7A;
  --moller-palette-error-60: #FF7461;
  --moller-palette-error-50: #F85B4C;
  --moller-palette-error-40: #EA443B;
  --moller-palette-error-30: #AB1E14;
  --moller-palette-error-20: #570800;
  --moller-palette-error-10: #330000;
  --moller-palette-neutral-variant-95: #F1F1F1;
  --moller-palette-neutral-variant-90: #D8D8D8;
  --moller-palette-neutral-variant-80: #C4C6C7;
  --moller-palette-neutral-variant-70: #9E9FA0;
  --moller-palette-neutral-variant-60: #8E8F90;
  --moller-palette-neutral-variant-50: #7C7D7E;
  --moller-palette-neutral-variant-40: #5A5B5C;
  --moller-palette-neutral-variant-30: #464748;
  --moller-palette-neutral-variant-20: #303132;
  --moller-palette-neutral-variant-10: #161718;
  --moller-palette-tertiary-95: #E8FFF1;
  --moller-palette-tertiary-90: #CFFFE3;
  --moller-palette-tertiary-80: #A8FFCC;
  --moller-palette-tertiary-70: #78FAAE;
  --moller-palette-tertiary-60: #72E3A1;
  --moller-palette-tertiary-50: #59BC87;
  --moller-palette-tertiary-40: #419468;
  --moller-palette-tertiary-30: #31694B;
  --moller-palette-tertiary-20: #2D5540;
  --moller-palette-tertiary-10: #263E31;
  --moller-palette-info-95: #DBE5FF;
  --moller-palette-info-90: #B6CFFF;
  --moller-palette-info-80: #96BDFE;
  --moller-palette-info-70: #7AACF8;
  --moller-palette-info-60: #609EEE;
  --moller-palette-info-50: #4A91E1;
  --moller-palette-info-40: #3784D1;
  --moller-palette-info-30: #14579C;
  --moller-palette-info-20: #012A55;
  --moller-palette-info-10: #00162E;
  --moller-palette-success-95: #DBF8DB;
  --moller-palette-success-90: #B6EEB6;
  --moller-palette-success-80: #96E292;
  --moller-palette-success-70: #7BD26D;
  --moller-palette-success-60: #62C049;
  --moller-palette-success-50: #4BAA24;
  --moller-palette-success-40: #359204;
  --moller-palette-success-30: #1D7200;
  --moller-palette-success-20: #0B4200;
  --moller-palette-success-10: #032100;
  --moller-palette-warning-95: #FFF8DB;
  --moller-palette-warning-90: #FFECB6;
  --moller-palette-warning-80: #FFDC92;
  --moller-palette-warning-70: #FFC86D;
  --moller-palette-warning-60: #F7B149;
  --moller-palette-warning-50: #E9992B;
  --moller-palette-warning-40: #D87F16;
  --moller-palette-warning-30: #A65900;
  --moller-palette-warning-20: #572F00;
  --moller-palette-warning-10: #331E00;
  --moller-palette-neutral-95: #F1F1F1;
  --moller-palette-neutral-90: #D8D8D8;
  --moller-palette-neutral-80: #C4C6C7;
  --moller-palette-neutral-70: #9E9FA0;
  --moller-palette-neutral-60: #8E8F90;
  --moller-palette-neutral-50: #7C7D7E;
  --moller-palette-neutral-40: #5A5B5C;
  --moller-palette-neutral-30: #464748;
  --moller-palette-neutral-20: #303132;
  --moller-palette-neutral-10: #161718;
  --moller-palette-secondary-95: #E8FFF1;
  --moller-palette-secondary-90: #CFFFE3;
  --moller-palette-secondary-80: #A8FFCC;
  --moller-palette-secondary-70: #78FAAE;
  --moller-palette-secondary-60: #72E3A1;
  --moller-palette-secondary-50: #59BC87;
  --moller-palette-secondary-40: #419468;
  --moller-palette-secondary-30: #31694B;
  --moller-palette-secondary-20: #2D5540;
  --moller-palette-secondary-10: #263E31;
  --moller-palette-primary-95: #E8FFF1;
  --moller-palette-primary-90: #CFFFE3;
  --moller-palette-primary-80: #A8FFCC;
  --moller-palette-primary-70: #78FAAE;
  --moller-palette-primary-60: #72E3A1;
  --moller-palette-primary-50: #59BC87;
  --moller-palette-primary-40: #419468;
  --moller-palette-primary-30: #31694B;
  --moller-palette-primary-20: #2D5540;
  --moller-palette-primary-10: #263E31;
  ${globalTextStyles}
    }
`;
export {
  RegisterSkodaDarkTheme
};
